import React, { useEffect, useState } from 'react';

export interface ModalBaseProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  headerClassName?: string;
  titleClassName?: string;
  mainClassName?: string;
  containerClassName?: string;
}

export const ModalBase: React.FC<React.PropsWithChildren<ModalBaseProps>> = ({
  isOpen,
  onClose,
  title,
  children,
  headerClassName = 'bg-white border-gray-200',
  titleClassName = 'text-gray-800',
  mainClassName = '',
  containerClassName = 'max-w-3xl',
}) => {
  const [isLogoViewerOpen, setIsLogoViewerOpen] = useState(false);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      setIsLogoViewerOpen(false); // Reset viewer state on modal open/close
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const modalTitleId = `modal-title-${title.replace(/\s+/g, '-').toLowerCase()}`;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-75 flex items-center justify-center p-4 z-[60]"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby={modalTitleId}
    >
      <div
        className={`bg-white rounded-xl shadow-2xl w-full flex flex-col max-h-[90vh] relative ${containerClassName}`}
        onClick={(e) => e.stopPropagation()}
      >
        <header className={`flex justify-between items-center p-6 border-b sticky top-0 rounded-t-xl ${headerClassName}`}>
          <div 
            className="flex items-center gap-4"
            onMouseEnter={() => setIsLogoViewerOpen(true)}
            onMouseLeave={() => setIsLogoViewerOpen(false)}
          >
             <img src="images/Logo_multas.eu_2025-06-26_10-41-03.png" alt="Multas.EU Logo" className="h-10 cursor-pointer" />
            <h2 id={modalTitleId} className={`text-2xl font-bold ${titleClassName}`}>{title}</h2>
          </div>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-gray-600 text-3xl p-1"
            aria-label="Cerrar modal"
          >
            &times;
          </button>
        </header>
        <main className={`p-8 overflow-y-auto text-gray-600 leading-relaxed ${mainClassName}`}>
            {children}
        </main>
        
        {/* Logo Viewer Submodal */}
        <div
            className={`absolute inset-0 bg-black bg-opacity-90 flex items-center justify-center rounded-xl z-10 transition-opacity duration-300 ${isLogoViewerOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
            aria-hidden="true"
        >
            <img
                src="images/Logo_multas.eu_2025-06-26_10-41-03.png"
                alt="Logo de Multas.EU ampliado"
                style={{ height: '512px' }}
                className="object-contain"
            />
        </div>
      </div>
    </div>
  );
};